<template>
    <popup ref="popup" class="popup" :show.sync="openPop" :hideTitle="true">
        <div class="container">
            <div class="list">
            <div class="checkbox-item" v-for="(opt,index) in options" @click="click(index)">
                <span :class='[{"choosed":opt.isChoosed},{"input-checkbox":!opt.isChoosed}]'></span>
                <span class="checkbox-text">{{ opt.text }}</span>
              </div>
        </div>
        <div class="footer">
            <div class="confirm-button" @click="confirm">确定</div>
        </div>
        </div>
    </popup>
</template>
<script>
import Popup from '@/components/Popup';
export default {
  components: {
    Popup,
  },
  data() {
    return {
      openPop: false,
      options: [],
      choosedValue: [],
    };
  },
  methods: {
    show(params) {
      setTimeout(() => {
        this.openPop = true;
      }, 400);
      this.options = this.handleoptions(params.options);
      this.widgetSymbol = params.widgetSymbol;
    },
    cancel() {
      this.openPop = false;
    },
    confirm() {
      const choosedOptions = this.options.filter(item => item.isChoosed);
      const result = [];
      choosedOptions.length && choosedOptions.forEach(item => result.push(item));
      this.$emit('multipleSelectChange', {
        choosed: result,
        widgetSymbol: this.widgetSymbol,
      });
      this.openPop = false;
    },
    // 处理一下选项，加一个是否被选中的标记
    handleoptions(options) {
      const result = [];
      options && options.forEach((item) => {
        result.push({
          value: item.value,
          isChoosed: false,
          text: item.text,
        });
      });
      return result;
    },
    click(index) {
      if (index > -1) {
        this.options[index].isChoosed = !this.options[index].isChoosed;
      }
    },
  },
};
</script>

<style lang="less" scoped>
    .container {
        padding: 32px 16px 16px;
        box-sizing: border-box;

    }
    .list {
        .checkbox-item {
            border-bottom: 1px solid #EBEDF0;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            font-size: 14px;
            line-height: 20px;
            padding: 10px 0;
            .input-checkbox {
                width: 18px;
                height: 18px;
                display: inline-block;
                border-radius: 100%;
                border: 1px solid #969799;
                margin-right: 8px;
                box-sizing: border-box;
            }
            .checkbox-text {
                flex: 1;
            }
            .choosed {
                width: 18px;
                height: 18px;
                display: inline-block;
                background: url('./assets/choosded.svg');
                background-size: 18px 18px;
                margin-right: 8px;

            }
        }
        .checkbox-item:last-child {
            border-bottom: none;
        }
    }
    .footer {
      margin-top: 16px;
        box-sizing: border-box;
        width: 100%;
        .confirm-button {
            box-sizing: border-box;
            text-align: center;
            padding: 10px 0;
            line-height: 20px;
            background: #4A70FF;
            color: #FFF;
            font-size: 14;
            border-radius: 3px;
        }
     }
</style>
